import React from 'react';
import { Box, SxProps } from '@mui/material';

import { humanCase } from '@paragon/utilities';

import { MultiValueNumberInput } from '../../multi-value-controls/MultiValueNumberInput';
import { LoadSettingsControlProps } from '../LoadSettingsControls';

const allLoadTypes = ['dead', 'floorLive', 'roofLive', 'wind', 'tornado', 'snow', 'rain', 'drag', 'person'] as const;
type LoadDurationFactorType = (typeof allLoadTypes)[number];

export function DurationFactorSetting({
  sx,
  loadType,
  hasDolHeader,
  disabled,
  loadSettingsArray,
  setLoadSettingsValues,
}: LoadSettingsControlProps & {
  readonly loadType: LoadDurationFactorType;
  readonly hasDolHeader?: boolean;
  sx?: SxProps;
}) {
  return (
    <MultiValueNumberInput
      sx={sx}
      values={loadSettingsArray.map((loadSettings) => loadSettings[`${loadType}DurationFactor`])}
      submit={(value) => setLoadSettingsValues({ [`${loadType}DurationFactor`]: value })}
      label={hasDolHeader ? humanCase(loadType) : `${humanCase(loadType)} DOL`}
      disabled={disabled}
      min={0}
      // The duration factor for person loads is explicitly limited to 1.6 in TPI 1-2022 Section 6.2.2.5.
      // Impact loads are the briefest loads and have duration factor 2.0, per TPI 1 Table 6.4-1.
      max={loadType === 'person' ? 1.6 : 2}
    />
  );
}

export function DurationFactorSettings({
  loadTypes,
  hasDolHeader,
  disabled,
  loadSettingsArray,
  setLoadSettingsValues,
}: LoadSettingsControlProps & {
  readonly loadTypes?: readonly LoadDurationFactorType[];
  readonly hasDolHeader?: boolean;
}) {
  return (
    <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(100px, 1fr))' }}>
      {(loadTypes ?? allLoadTypes).map((loadType) => (
        <DurationFactorSetting
          sx={{ m: 1 }}
          loadType={loadType}
          hasDolHeader={hasDolHeader}
          disabled={disabled}
          loadSettingsArray={loadSettingsArray}
          setLoadSettingsValues={setLoadSettingsValues}
          key={loadType}
        />
      ))}
    </Box>
  );
}
